import styled from 'styled-components'
import React from 'react'
import MSIcon from 'images/MS_icon.svg'

const MicrosoftButton = ({ onClick }) => {
  return (
    <StyledMicrosoftButton onClick={onClick}>
      <StyledMSIcon>
        <img src={MSIcon} />
      </StyledMSIcon>
      <span style={{ marginLeft: "-38px" }}>
        Microsoft
      </span>
    </StyledMicrosoftButton>
  )
}

const StyledMicrosoftButton = styled.div`
  font-family: Roboto, arial, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 1);
  cursor: pointer;
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: none !important;
  border-radius: 0.3rem !important;
  border: 1px solid #d9d9d9 !important;
  line-height: 38px !important;
  width: 100%;
  text-align: center;
  justify-content: center;
  display: block;

  &:hover {
    border: 1px solid #59b2d9 !important;
  }
`

const StyledMSIcon = styled.div`
  margin-left: 1px;
  float: left;
  width: 38px;
  height: 38px;
`

export default MicrosoftButton
